/** Workforce tracks for multi-calendar roster planner. */

export const ROSTER_TRACKS = [
  {
    id: 'doctor',
    clinicRole: null,
    label: 'Doctors',
    shortLabel: 'Doctors',
    staffNoun: 'doctor',
    staffNounPlural: 'doctors',
    accent: '#F15A22',
    hero: 'Bulk-allocate doctors for a week or month, then publish for online booking.',
    emptyHint: 'No doctor duties this period — bulk allocate a pattern.',
    bookingAware: true,
    presets: [
      { id: 'morning', label: 'Morning OPD', start: '09:00', end: '13:00', location: 'OPD Block A — Morning' },
      { id: 'afternoon', label: 'Afternoon OPD', start: '14:00', end: '17:00', location: 'OPD Block A — Afternoon' },
      { id: 'evening', label: 'Evening', start: '17:00', end: '20:00', location: 'OPD Block B — Evening' },
    ],
    defaultLocation: 'OPD Block A — Morning',
  },
  {
    id: 'staff_nurse',
    clinicRole: 'staff_nurse',
    label: 'Staff Nurses',
    shortLabel: 'Nurses',
    staffNoun: 'nurse',
    staffNounPlural: 'nurses',
    accent: '#0D9488',
    hero: 'Plan nursing cover across OPD and wards. Publish to confirm the duty roster.',
    emptyHint: 'No nursing duties this week — bulk allocate a pattern.',
    bookingAware: false,
    presets: [
      { id: 'day', label: 'Day duty', start: '07:00', end: '15:00', location: 'Nursing station — OPD' },
      { id: 'eve', label: 'Evening', start: '14:00', end: '22:00', location: 'Nursing station — Ward' },
      { id: 'night', label: 'Night', start: '22:00', end: '07:00', location: 'Nursing station — Night' },
    ],
    defaultLocation: 'Nursing station — OPD',
  },
  {
    id: 'multi_skill_assistant',
    clinicRole: 'multi_skill_assistant',
    label: 'Multi Skill Assistants',
    shortLabel: 'MSA',
    staffNoun: 'assistant',
    staffNounPlural: 'assistants',
    accent: '#475569',
    hero: 'Schedule floor support, transport, and clinical assistance shifts.',
    emptyHint: 'No MSA duties this period — allocate a weekly pattern.',
    bookingAware: false,
    presets: [
      { id: 'opd', label: 'OPD support', start: '08:00', end: '16:00', location: 'OPD floor support' },
      { id: 'desk', label: 'Sample desk', start: '12:00', end: '20:00', location: 'Sample / transport desk' },
    ],
    defaultLocation: 'OPD floor support',
  },
  {
    id: 'lab_technician',
    clinicRole: 'lab_technician',
    label: 'Lab Technicians',
    shortLabel: 'Lab',
    staffNoun: 'technician',
    staffNounPlural: 'technicians',
    accent: '#4F46E5',
    hero: 'Cover clinical lab and sample receiving with a clear duty calendar.',
    emptyHint: 'No lab duties this period — bulk allocate cover.',
    bookingAware: false,
    presets: [
      { id: 'lab', label: 'Clinical lab', start: '08:30', end: '16:30', location: 'Clinical Lab' },
      { id: 'recv', label: 'Receiving', start: '10:00', end: '18:00', location: 'Sample receiving' },
    ],
    defaultLocation: 'Clinical Lab',
  },
];

export function trackById(id) {
  return ROSTER_TRACKS.find((t) => t.id === id) || ROSTER_TRACKS[0];
}
